import * as React from 'react'
import styled     from 'styled-components'

interface SlideProps {
  backgroundUrl: string
  isChanging: boolean
  transitionTime: number
}

const Slide = styled.div`
  height: 100%;
  width: 100%;
  background: url('${({ backgroundUrl }: SlideProps) => backgroundUrl }');
  background-size: cover;
  transition: ${({ transitionTime }) => transitionTime }ms;
`

interface SlideShowProps {
  time?: number
  transitionTime?: number
  images: string []
}

const defaults = {
  time:           2500,
  transitionTime: 500,
}

interface State {
  currentImage: number
  isChanging: boolean
  loadedImages: number []
}

class SlideShow extends React.Component<SlideShowProps, State> {
  public static defaultProps = defaults

  public state = {
    currentImage: 0,
    isChanging:   true,
    loadedImages: [] as number [],
  }

  public constructor (props) {
    super(props)

    this.props.images.forEach(this.preloadImage)
  }

  public componentDidMount () {
    this.setState({ isChanging: false })

    this.setTimer()
  }

  public render () {
    const { children, images, transitionTime } = this.props
    const { currentImage, isChanging } = this.state

    const currentImageUrl = images[ currentImage ]

    return (
      <Slide
        transitionTime={transitionTime as number}
        isChanging={isChanging}
        backgroundUrl={currentImageUrl}
      >
        {children}
      </Slide>
    )
  }

  private preloadImage = (img: string, index: number) => {
    const image = new Image()
    image.src = img
    image.onload = () => { this.registerLoadedImage(index) }
  }

  private registerLoadedImage = (index: number) => {
    this.setState(state => ({ loadedImages: [ ...state.loadedImages, index ] }))
  }

  private setTimer = (time?: number) => {
    setTimeout(
      this.changeSlide,
      time || this.props.time,
    )
  }

  private changeSlide = () => {
    const { loadedImages, currentImage } = this.state

    const nextSlideIsLoaded = loadedImages.indexOf(currentImage) !== -1

    if (nextSlideIsLoaded) {
      setTimeout(
        this.switchSlides,
        this.props.transitionTime,
      )
    } else {
      /* try again in 200 ms */
      this.setTimer(200)
    }
  }

  private switchSlides = () => {
    this.hideCurrentSlide()

    setTimeout(
      this.showNextSlide,
      this.props.transitionTime,
    )
  }

  private hideCurrentSlide = () => {
    this.setState({ isChanging: true })
  }

  private showNextSlide = () => {
    const { currentImage } = this.state
    const { images } = this.props

    const hasHitEnd = images.length - 1 === currentImage

    this.setState(state => ({
      isChanging:   false,
      currentImage: hasHitEnd
                      ? 0
                      : state.currentImage + 1
    }))

    this.setTimer()
  }
}

export default SlideShow



// WEBPACK FOOTER //
// ./src/components/organisms/SlideShow.tsx